export interface TourSignoffItem {
  description: string
  label: string
}
